var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('project-information', {
    attrs: {
      "project": _vm.project,
      "graph": _vm.graph
    }
  }, [_vm.graph.length > 0 ? _c('transaction-chart', {
    attrs: {
      "slot": "graph",
      "data": _vm.graph
    },
    slot: "graph"
  }) : _vm._e()], 1), _vm.isPersonalProject ? [_c('project-control', {
    directives: [{
      name: "m-x",
      rawName: "v-m-x",
      value: 20,
      expression: "20"
    }, {
      name: "m-y",
      rawName: "v-m-y",
      value: 20,
      expression: "20"
    }],
    attrs: {
      "project": _vm.project
    }
  }), _c('responsive-controller', {
    scopedSlots: _vm._u([{
      key: "laptop",
      fn: function fn() {
        return [_c('div', {
          class: _vm.$style.carusel
        }, [_c('functional-banners-carusel')], 1)];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('div')];
      },
      proxy: true
    }], null, false, 3683704245)
  })] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }